import axios from 'axios';
import { DEFAULT_API_URL, DEFAULT_LOCAL_PATH } from './constents';
import { persistor } from './redux/store';

const instance = axios.create({
  baseURL: DEFAULT_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const cancelMap = new Map();

let activeRequests = 0;

const showLoader = () => {
  activeRequests++;
  const loader = document.querySelector('.loader-body');
  if (loader) loader.classList.remove('hidden');
};

const hideLoader = () => {
  activeRequests--;
  if (activeRequests <= 0) {
    activeRequests = 0;
    const loader = document.querySelector('.loader-body');
    if (loader) loader.classList.add('hidden');
  }
};

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if (!config.silent) {
      showLoader();
    }

    // Create a unique key for each request
    const requestKey = `${config.method}:${config.url}`;

    // Cancel the previous request if it's still pending
    if (cancelMap.has(requestKey)) {
      cancelMap.get(requestKey).cancel('Canceled due to a new request.');
    }

    // Create a new cancel token
    const source = axios.CancelToken.source();
    config.cancelToken = source.token;

    // Save the cancel token in the map
    cancelMap.set(requestKey, source);

    return config;
  },
  function (error) {
    // Do something with request error
    hideLoader();
    return Promise.reject(error);
  },
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (!response.config.silent) {
      hideLoader();
    }

    // Remove the cancel token from the map after the request is completed
    const requestKey = `${response.config.method}:${response.config.url}`;
    cancelMap.delete(requestKey);

    return response;
  },
  function (error) {
    if (axios.isCancel(error)) {
      // Even if canceled, we need to decrement the counter
      if (!error.config?.silent) {
        hideLoader();
      }
      return new Promise(() => {}); // return a pending promise to avoid error
    }

    if (error.response?.status === 401) {
      persistor.pause();
      persistor.purge().then(() => {
        localStorage.clear();
        window.location.href = `${DEFAULT_LOCAL_PATH}`;
      });
    }

    // Do something with response error
    if (!error.config?.silent) {
      hideLoader();
    }

    // Remove the cancel token from the map in case of error
    if (error.config) {
      const requestKey = `${error.config.method}:${error.config.url}`;
      cancelMap.delete(requestKey);
    }

    return Promise.reject(error);
  },
);

export default instance;
